module.exports = __webpack_public_path__ + "img/H-63-ST-1000-BE.0492f87d.png";